import React from 'react';

const GrafanaEmbed = () => {

  let currentTheme = localStorage.getItem('appTheme')
  const isDark = Boolean(currentTheme === 'dark');
  let iframeUrl = `https://grafana.opsctl.com/d-solo/kXb8mnYnk/test-dashboard?orgId=1&from=1600840440379&to=1626013434515&theme=${isDark ? 'dark' : 'light'}&panelId=2`;

  return (
    <React.StrictMode>
      <div>
        <iframe
          src={iframeUrl}
          frameBorder={0}
          width={750}
          height={400}
        // allowTransparency
        />
      </div>
    </React.StrictMode>

  );
};

export default GrafanaEmbed;
